<template>
  <div class="container">
    {{ message }}<br>
  </div>
</template>

<script>
export default {
  name: 'error',
  data () {
    return {
      screenTitle: 'アクセスエラー'
    }
  },

  props: {
    message: null
  },

  mounted () {
    this.$emit('setScreenTitle', this.screenTitle)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/Error.vue